module.exports = __webpack_public_path__ + "img/bm.f1af119a.svg";